import { useDetectRefScroll } from "@faire/web/ui/hooks/useDetectScroll";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { useEffect } from "react";
import { useState } from "react";

const ALL_VIEWPORTS_NAVIGATION_BLOCK_SIZE = 96;

export const useModalScrolling = (hasImage: boolean) => {
  const { isMobile } = useViewport();
  const [showDivider, setShowDivider] = useState(false);
  const [navigationOpacity, setNavigationOpacity] = useState(hasImage ? 0 : 1);

  const { scrollState, refCallBack } = useDetectRefScroll("y", 0);
  useEffect(() => {
    setShowDivider(scrollState.scrollPosition > 0);

    setNavigationOpacity(
      hasImage && isMobile
        ? Math.min(
            Math.round(
              (scrollState.scrollPosition /
                ALL_VIEWPORTS_NAVIGATION_BLOCK_SIZE) *
                100
            ) / 100,
            1
          )
        : 1
    );
  }, [hasImage, isMobile, scrollState, showDivider]);

  return {
    showDivider,
    navigationOpacity,
    refCallBack,
  };
};
